// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__3i6w7","Success":"Button_Success__39Bcb","Danger":"Button_Danger__VoJEE"};